import { DASHBOARD_CONTAINER, PAGE_LOADER } from '../../../../types/types';
import { parseCardGroupInfo, getTerminalData } from '../form-tcg-helpers';
import { LINK_CG_TERMINAL_FORM } from '../form-tcg-types';
import { displayTerminals } from '../../../widgets/cg-terminal-widget';
import { searchClear } from '../../form-search';
import { ILinkedTerminals } from '../../../../models/cardgroup.interface';

import GetCardGroupTerminal from '../../../../routes/get-cardgroup-terminal';
import { getTerminals } from '../../../../routes/get-terminal';
import { addCardGroupTerminal } from './add-cardgroup-terminal';

/**
 * Links a terminal or terminals to an individual Card Group
 * 
 * @param {String} customerId the customer id
 * @param {String} cardGroupID the card group id
 * 
 * @returns void
 */
export const linkCardGrouptoTerminal = async ( customerId: string, cardGroupID: string ) => {

  const awsModelData = {
    customerId: +customerId,
    cardgroupId: +cardGroupID
  }

  const [ cardGroup, allTerminals ] = await Promise.all([
    GetCardGroupTerminal(awsModelData),
    getTerminals(),
  ]); 

  const { body: { cg, c, t } } = cardGroup; 
  const { partner } = c[0];
  const { linked } = t;

  const avalTerminal = allTerminals.body.filter(item => linked.every(item2 => item2.termId != item.terminalId));

  parseCardGroupInfo(cg, c);
  getTerminalData(avalTerminal); 
  displayTerminals(linked, customerId, cardGroupID, String(partner), LINK_CG_TERMINAL_FORM.searchSelected);

  getSelectedTerminal(LINK_CG_TERMINAL_FORM.searchResults, LINK_CG_TERMINAL_FORM.searchSelected, customerId, cardGroupID);

  PAGE_LOADER.loaderContainer.classList.add('aafp_no-show');
  DASHBOARD_CONTAINER.removeAttribute('style');
}

/**
 * Selects and removes Terminals from the available terminals list
 * 
 * @param {HTMLElement} avalContainer the HTML element that has available terminals
 * @param {HTMLElement} resultsContainer the HTML element that has associated terminals
 * 
 * @returns void
 */
const getSelectedTerminal = (avalContainer: HTMLElement, resultsContainer: HTMLElement, customerID: string, cardGroupID: string): void => {
  avalContainer?.addEventListener('click', e => {
    let data: Array<ILinkedTerminals> = [];
    const target = e.target as HTMLElement;

    if(target != this && target.classList.contains('get-selected-element')) {
      data.push({ termId: target.dataset.id!, termName: target.dataset.name!, partnerName: target.dataset.partnername!, partnerId: +target.dataset.partner!, displayTax: '' });        
      displayTerminals(data, customerID, cardGroupID, target.dataset.partner!, resultsContainer);
      target.parentElement!.remove();
      addCardGroupTerminal( cardGroupID );      
    } 

    searchClear(LINK_CG_TERMINAL_FORM.searchInput, LINK_CG_TERMINAL_FORM.searchResults);
  });
}